import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const personnelTypeMap = {
    transfer: "人事调动",
    cancel: "人员注销",
}

const unitFilterTypeMap = {
    unit: "科室",
    transferIn: "调入科室",
    transferOut: "调出科室",
}

const initState = {
    initializing: true,
    tableLoading: false, // 表格加载
    personnelType: "transfer", // 人事变动类型
    unitFilterType: "unit", // 科室筛选条件
    selectedUnitIds: null, // 选中的科室ids
    unitsMap: null,
    transferReason: 0, // 选中的原因，0为全部
    users: null, // 查找到的人员
    keyword: "", // 搜索keyword

    dicts: null, // 注销调动原因字典
    editOptionModalVisible: false, // 字典更改mdal
    editOptions: null, // 更改的选项
    editOptionModalLoading: false, // 字典更改保存loading

    unmarkedCount: 0,

    datePicker: {
        beginDate: null, // datepicker开始时间
        endDate: null, // datepicker结束时间
    },
    cancelDatePicker: {
        beginDate: null,
        endDate: null,
    }, // 人员注销查询时间

    editModalVisible: false, // 编辑 modal
    editUser: null, // 编辑中的人员
    editLoading: false, // 编辑loading
    checkedUsers: null, // 选中的人员
    groupEditModalVisible: false, // 批量编辑modal

    pageable: {
        current: 1,
        limit: 30,
    }
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
    personnelTypeMap,
    unitFilterTypeMap,
};
export default viewModel;
